import { render, staticRenderFns } from "./DomainDetail.vue?vue&type=template&id=356042ac&scoped=true"
import script from "./DomainDetail.vue?vue&type=script&lang=js"
export * from "./DomainDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356042ac",
  null
  
)

export default component.exports